module.exports = __webpack_public_path__ + "img/6.f88ae772.png";